module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/home/armchair-6f1381b58ddfcbdadb660c9569f98f9f.svg";